export default "__VITE_ASSET__CJuXM4gU__"